import { createFileRoute } from '@tanstack/react-router';

import { useTelegramBackButton } from '@common/hooks';
import { Page } from '@common/ui/Page';

import { ChatSafetyContextProvider } from '@entities/chat/contexts';

import { Chat } from '@widgets/chats/Chat';

export const Route = createFileRoute('/chats/$matchId')({
  component: Component,
  params: {
    parse: (params) => params,
  },
});

export default function Component() {
  const { matchId } = Route.useParams();
  useTelegramBackButton({ to: 'back' });

  return (
    <>
      <Page
        hasBackground
        style={{
          minHeight: '0',
          height: '100%',
          overflow: 'hidden',
          touchAction: 'none',
          overscrollBehaviorY: 'none',
        }}
      >
        <ChatSafetyContextProvider>
          <Chat matchId={matchId} />
        </ChatSafetyContextProvider>
      </Page>
    </>
  );
}
